/* eslint-disable */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { GET_FORMDATA_ORDINANCE_REVISION } from '../components/constant';

import NewFixedFeesContainer from './newFixedFees/container/NewFixedFeesContainer';
import NewOtherFeesContainer from './newOtherFees/container/NewOtherFeesContainer';
import NewTaxRevenuesGarbageContainer from './newTaxRevenues/garbage/container/NewTaxRevenuesContainer';
import NewTaxRevenuesLicenseContainer from './newTaxRevenues/license/container/NewTaxRevenuesContainer';
import NewTaxRevenuesPermitContainer from './newTaxRevenues/permit/container/NewTaxRevenuesContainer';
import NewTaxRevenuesSanitaryContainer from './newTaxRevenues/sanitary/container/NewTaxRevenuesContainer';

import OrdinaceRevisionDropDown from '../components/OrdinanceRevisionDropDown'; // move the location higher

function TaxRevenuesContainer({ match, pathName, fetchedDefaultOption }) {
  const dropDownFormData = useSelector(
    ({ api }) => _.get(api, `${GET_FORMDATA_ORDINANCE_REVISION}.item`) || {}
  );

  const ordinanceRevisionId =
    parseInt(_.get(dropDownFormData, 'year.value')) ||
    parseInt(_.get(fetchedDefaultOption, 'year.value')) ||
    0;
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row d-flex justify-content-between flex-row align-items-end">
            <div className="col-sm-12 col-lg-8">
              <ul className="nav nav-tabs btn-settings-tab-container">
                <li className="nav-item">
                  <Link
                    to="/bpls/tax-revenue/license"
                    className={`nav-link btn-settings-tab border-right py-3 px-4 ${
                      pathName.indexOf('bpls/tax-revenue/license') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    License
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/bpls/tax-revenue/permit"
                    className={`nav-link btn-settings-tab border-right py-3 px-4 ${
                      pathName.indexOf('bpls/tax-revenue/permit') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Permit
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/bpls/tax-revenue/sanitary"
                    className={`nav-link btn-settings-tab border-right py-3 px-4 ${
                      pathName.indexOf('bpls/tax-revenue/sanitary') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Sanitary
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/bpls/tax-revenue/garbage"
                    className={`nav-link btn-settings-tab border-right py-3 px-4 ${
                      pathName.indexOf('bpls/tax-revenue/garbage') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Garbage
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/bpls/tax-revenue/new-fixed-fees"
                    className={`nav-link btn-settings-tab border-right py-3 px-4 ${
                      pathName.indexOf('bpls/tax-revenue/new-fixed-fees') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Fixed Fees
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/bpls/tax-revenue/new-other-fees"
                    className={`nav-link btn-settings-tab border-right py-3 px-4 ${
                      pathName.indexOf('bpls/tax-revenue/new-other-fees') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Other Fees
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-sm-12 col-lg-4">
              <div
                className="d-flex justify-content-end align-items-center pb-2 pr-4"
                style={{ flexGrow: '2' }}
              >
                <OrdinaceRevisionDropDown pathName={pathName} />
              </div>
            </div>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/license`} />}
          />
          <Route
            path={`${match.path}/garbage`}
            render={() => (
              <NewTaxRevenuesGarbageContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
          <Route
            path={`${match.path}/license`}
            render={() => (
              <NewTaxRevenuesLicenseContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
          <Route
            path={`${match.path}/permit`}
            render={() => (
              <NewTaxRevenuesPermitContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
          <Route
            path={`${match.path}/sanitary`}
            render={() => (
              <NewTaxRevenuesSanitaryContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
          <Route
            path={`${match.path}/new-fixed-fees`}
            render={() => (
              <NewFixedFeesContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
          <Route
            path={`${match.path}/new-other-fees`}
            render={() => (
              <NewOtherFeesContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

TaxRevenuesContainer.defaultProps = {
  fetchDefaultOption: {},
};

TaxRevenuesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  fetchedDefaultOption: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }, { match, location }) => {
  const fetchDefaultOption = () => {
    try {
      return JSON.parse(localStorage.getItem('defaultFormValue'));
    } catch (err) {
      return {};
    }
  };

  return {
    fetchedDefaultOption: fetchDefaultOption(),
    mainModule: _.get(match, 'params.mainModule'),
    pathName: _.get(location, 'pathname'),
    profile: _.get(api, 'AUTH/user_profile.item') || {},
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(TaxRevenuesContainer);
